export default __webpack_public_path__ + "static/contents-back-8d57f1cd80545f0e0dbdc71669c23e2f.png";